export default function GetQueryString (QueryString) {  
 const arr = QueryString.split('&')
 const len = arr.length
 let obj = {}
 for(var i in arr){
  obj[arr[i].split("=")[0]] = arr[i].split("=")[1];
 }
 return obj
}